import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrls: ['./skills.component.scss']
})
export class SkillsComponent implements OnInit {
  frontEndSkills = [];
  backEndSkills = [];
  databaseSkills = [];
  queryInterfaces = [];
  serverLess = [];
  otherSkills = [];

  constructor() { }

  ngOnInit(): void {
    this.frontEndSkills = [
      {
        image: "assets/images/skills/html-5.png",
        name: "HTML5"
      },
      // {
      //   image: "assets/images/skills/jquery.png",
      //   name: "jQuery"
      // },
      {
        image: "assets/images/skills/css.png",
        name: "CSS3"
      },
      {
        image: "assets/images/skills/sass.png",
        name: "SASS"
      },
      {
        image: "assets/images/skills/bootstrap.png",
        name: "Bootstrap"
      },
      {
        image: "assets/images/skills/javascript.png",
        name: "Javascript"
      },
      {
        image: "assets/images/skills/ts.png",
        name: "Typescript"
      },
      {
        image: "assets/images/skills/angular.png",
        name: "Angular"
      }
    ];
    this.backEndSkills = [
      {
        image: "assets/images/skills/php.png",
        name: "PHP"
      },
      {
        image: "assets/images/skills/laravel.png",
        name: "Laravel"
      },
      {
        image: "assets/images/skills/nodejs.png",
        name: "Nodejs"
      }
    ];
    this.databaseSkills = [
      {
        image: "assets/images/skills/mysql.png",
        name: "Mysql"
      },
      {
        image: "assets/images/skills/postgres.png",
        name: "PostgreSQL"
      },
      {
        image: "assets/images/skills/mongodb.png",
        name: "MongoDB"
      },
      // {
      //   image: "assets/images/skills/redis.png",
      //   name: "Redis"
      // },
      {
        image: "assets/images/skills/neo4j.png",
        name: "Neo4j"
      },
      {
        image: "assets/images/skills/neptune.png",
        name: "Neptune"
      }
    ];
    this.queryInterfaces = [
      {
        image: "assets/images/skills/sql.svg",
        name: "Sql"
      },
      {
        image: "assets/images/skills/sequelize.svg",
        name: "Sequelize"
      },
      {
        image: "assets/images/skills/gremlin.png",
        name: "Gremlin"
      }
    ];
    this.serverLess = [
      {
        image: "assets/images/skills/gitlabrun.png",
        name: "Gitlab Runner"
      },
      {
        image: "assets/images/skills/mocha.png",
        name: "Mocha"
      },
      {
        image: "assets/images/skills/chai.png",
        name: "Chai"
      },
      {
        image: "assets/images/skills/aws.png",
        name: "AWS"
      },
      {
        image: "assets/images/skills/s3.png",
        name: "S3"
      },
      {
        image: "assets/images/skills/cdn.png",
        name: "CDN"
      },
      {
        image: "assets/images/skills/lambda.svg",
        name: "Lambda"
      },
      {
        image: "assets/images/skills/apigateway.svg",
        name: "API Gateway"
      }
    ]
    this.otherSkills = [
      {
        image: "assets/images/skills/firebase.png",
        name: "Firebase"
      },
      {
        image: "assets/images/skills/godaddy.png",
        name: "GoDaddy"
      },
      {
        image: "assets/images/skills/github.png",
        name: "Github"
      },
      {
        image: "assets/images/skills/gitlab.png",
        name: "Gitlab"
      },
      {
        image: "assets/images/skills/docean.png",
        name: "Digital Ocean"
      },
      {
        image: "assets/images/skills/ubuntu.png",
        name: "Ubuntu"
      },
      {
        image: "assets/images/skills/shell.png",
        name: "Shell Script"
      },
      {
        image: "assets/images/skills/nginx.png",
        name: "Nginx"
      },
      {
        image: "assets/images/skills/apache.png",
        name: "Apache"
      },
      {
        image: "assets/images/skills/letencrpt.png",
        name: "Let's Encrypt"
      },
      {
        image: "assets/images/skills/mosquitto.png",
        name: "Mosquitto"
      },
      {
        image: "assets/images/skills/vscode.png",
        name: "Vscode"
      },
      {
        image: "assets/images/skills/photopea.png",
        name: "Photopea"
      }
    ]
  }

}
